//core
import React from "react";
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import { Box, Tooltip, Typography } from "@mui/material";

//styles
import { useStyles } from "./styles";

//icons
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/ErrorOutline";

type DuplicatedItem = {
  field: string;
  fullMatch: boolean;
};

interface IDuplicatedDataProps {
  value: DuplicatedItem[];
}

const DuplicatedData: React.FC<IDuplicatedDataProps> = ({ value }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!value || !Array.isArray(value) || value.length === 0) {
    return <>{'—'}</>;
  }

  return (
    <Box className={styles.wrapper}>
      {value.map((item) => (
        <Box key={item.field} className={styles.item}>
          <Typography variant="body2" className={styles.label}>
            {t(`admin.partners.account.multiAccounts.duplicatedFields.${item.field}`)}
          </Typography>
          <Tooltip
            title={
              item.fullMatch
                ? t("admin.partners.account.multiAccounts.fullMatch")
                : t("admin.partners.account.multiAccounts.partialMatch")
            }
          >
            {item.fullMatch ? (
              <ErrorIcon color="error" fontSize="small" />
            ) : (
              <WarningAmberIcon color="warning" fontSize="small" />
            )}
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(DuplicatedData, arePropsEqual);
